import { render, staticRenderFns } from "./ProjectTemplates.vue?vue&type=template&id=481e72d9&scoped=true&"
import script from "./ProjectTemplates.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplates.vue?vue&type=style&index=0&id=481e72d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e72d9",
  null
  
)

export default component.exports